import { Link, useLocation } from 'react-router-dom'
import { ShoppingBag, ArrowRight } from 'lucide-react'
import { useCart } from '../contexts/CartContext'
import { useTenant } from '../contexts/TenantContext'
import { useCurrency } from '../pages/customer/templates/shared'
import { t } from '../i18n'
export default function CartBottomBar() {
 const { items, total, itemCount } = useCart()
 const location = useLocation()
 const tenant = useTenant()
 const currency = useCurrency()
 if (!items.length || !(tenant.services || []).some(id => id === 'menu' || id === 'store') || /cart|checkout|order|reservations|account/.test(location.pathname)) return null
 return <div className="fixed bottom-4 start-4 end-4 z-40 md:hidden"><Link to={`/cart${location.search}`} className="sk-btn w-full justify-between shadow-xl !py-4"><span className="flex items-center gap-3"><ShoppingBag size={21}/><span>{itemCount} {t("items ·")} {Number(total).toFixed(2)} {currency}</span></span><ArrowRight size={20}/></Link></div>
}
